export const SUMMARY_MATERIAL_EXPORT_ID = "summary-material";
export const SUMMARY_MATERIAL_TITLE = "Resumen Material";
export const SUMMARY_MATERIAL_PROPERTIES = {
  trip: "Viaje",
  subRouteCode: "Código de ruta",
  subRouteName: "Ruta",
  materialCode: "Código de material",
  materialName: "Nombre de material",
  batch: "Lote",
  baseUnitOfMeasureName: "Unidad de Medida UMB",
  quantity: "Cantidad UMB",
  parallelUnitOfMeasureName: "Unidad de Medida UMP",
  parallelQuantity: "Cantidad UMP",
};
